import _extends from 'babel-runtime/helpers/extends';

import { platform } from '@/common/material-metadata';

export default {
  name: 'PlatformSelector',

  componentName: 'PlatformSelector',

  props: {
    config: {
      type: Object,
      required: true
    },
    formValue: {
      type: Object,
      required: true
    }
  },

  computed: {
    innerConfig: function innerConfig() {
      var params = _extends({
        placeholder: '请选择平台',
        clearable: true,
        disabled: false,
        options: platform
      }, this.config.params);
      return _extends({}, this.config, {
        params: params
      });
    }
  }
};